import {
  DirectionsBoatIcon as Sea,
  DirectionsRailwayIcon as Rail,
  LocalAirportIcon as Air,
  SeaAirIcon as SeaAir,
} from '@freighthub/silhouette-core'

export type TTransportMode = 'sea' | 'air' | 'seaAir' | 'rail'

export const TRANSPORT_MODES = ['sea', 'air', 'seaAir', 'rail']

export const transportModesIconMap = {
  sea: <Sea />,
  air: <Air />,
  seaAir: <SeaAir />,
  rail: <Rail />,
}

export const transportModesTranslationTokenMap: Record<TTransportMode | 'truck', string> = {
  sea: 'common-mode-sea',
  air: 'common-mode-air',
  seaAir: 'common-mode-sea_air',
  rail: 'common-mode-rail',
  truck: 'manual-quote-transport_to_port_mode_truck',
}
